/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)


// axios
import axios from './axios.js'
Vue.prototype.$http = axios

Vue.prototype.$printError = function (error) {

  if (error.length === 0) return

  this.$vs.notify({
    title:'Error',
    text: error,
    color:'danger',
    iconPack: 'feather',
    icon:'icon-alert-circle'})
}

Vue.prototype.$printSuccess = function (message) {
  this.$vs.notify({
    title:'Success',
    text: message,
    color:'success',
    iconPack: 'feather',
    icon:'icon-check-circle'})
}

// Filters
import './filters/filters.js'


// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'

//Moment.js
import moment from 'moment-timezone'
Vue.prototype.moment = moment

// Vuex Store
import store from './store/store'

// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';


Vue.config.productionTip = false

const pingPromise = axios.get('/api/reseller/v1/ping/')
pingPromise.then(function (response) {
  store.dispatch('setLoginStatus', true)
  store.dispatch('setCredits')
  if (response.data) store.dispatch('setDevelopment')
}).catch(function () {
  store.dispatch('setLoginStatus', false)
})

Promise.all([pingPromise]).finally(function () {
  axios.interceptors.response.use(function (response) {
    return response
  }, function (error) {
    if (error.response.status === 401) {
      store.dispatch('setLoginStatus', false)
      router.push('/login')
    }
    return Promise.reject(error)
  })

  const vueObject = new Vue({
    router,
    store,
    render: h => h(App)
  })

  vueObject.$mount('#app')

  axios.interceptors.response.use(function (response) {
    return response
  }, function (error) {
    if (error.response.status === 403) {

      if (error.response.data && error.response.data.length > 0) {
        vueObject.$vs.notify({
          title:'Forbidden',
          text: error.response.data,
          color:'danger',
          iconPack: 'feather',
          icon:'icon-lock'})
      } else {
        vueObject.$vs.notify({
          title:'Forbidden',
          text: 'You are not allowed to do that!',
          color:'danger',
          iconPack: 'feather',
          icon:'icon-lock'})
      }


    }
    return Promise.reject(error)
  })
})

